
namespace TabAurous.Administration {

    @Serenity.Decorators.registerClass()
    export class ItemDiscountDetailsDialog extends Serenity.EntityDialog<ItemDiscountDetailsRow,any> {
        protected getFormKey() { return ItemDiscountDetailsForm.formKey; }
       // protected getIdProperty() { return ItemDiscountDetailsRow.idProperty; }
        protected getLocalTextPrefix() { return ItemDiscountDetailsRow.localTextPrefix; }
        //protected getNameProperty() { return ItemDiscountDetailsRow.nameProperty; }
        //protected getService() { return ItemDiscountDetailsService.baseUrl; }
        //protected getDeletePermission() { return ItemDiscountDetailsRow.deletePermission; }
        //protected getInsertPermission() { return ItemDiscountDetailsRow.insertPermission; }
        //protected getUpdatePermission() { return ItemDiscountDetailsRow.updatePermission; }

        protected form = new ItemDiscountDetailsForm(this.idPrefix);

    }
}